<template>
<div class="container-fluid" v-if="$store.state.data.info.bibles.length && $store.state.data.current.chapter.verses.length">
  <div class="bible-open-head">
    <p class="mb-2">
      {{ $store.state.data.current.book.toc2 }}
      {{ $store.state.data.current.chapter.code }}
    </p>
  </div>
  <div class="row no-gutters bible-open-body">
    <b-list-group class="w-100 my-3">
      <b-list-group-item>
        <strong>著作権について</strong>
        <p>
          聖書の訳文は、著作権法によって保護されています。コピー機能は、著作権法30条に基づく私的使用、同法35条に基づく教育関係での使用、同法37条に基づく福祉関係での使用に限定してご利用くださいますよう、お願いします。
        </p>
        <strong>コピー内容について</strong>
        <p>
          レイアウト（段落、字下げ、節番号など）について、正確なコピーがされない場合があります。ご了承ください。
        </p>
        <b-form-textarea
          id="textarea-for-copy-chapter"
          v-model="text"
          style="display: none !important"
          @copy.native="onCopyNativeTextAreaForCopy"
          ></b-form-textarea>
        <b-button variant="light" class="w-100" @click="onClickCopy">同意して1章コピーする</b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</div>
</template>

<script>
import jQuery from 'jquery'
import { textify, } from '@/utils/tool'
import { normalizeChapterForCopy } from '@/utils/data';
import AppBuyLayer from '@/components/AppBuyLayer.vue'

export default {
  components: {
    AppBuyLayer,
  },
  data: function () {
    return {
      html: null,
      text: null,
      target: null,
      parallel: null,
      last_verse: null,
    }
  },

  methods: {
    onShown(event) {
      const html = document.querySelector('.bible-text>.html-container').innerHTML;
      const html_normalized = normalizeChapterForCopy(html);
      console.log('html_normalized');
      console.log(html_normalized);
      this.text = html_normalized;
//      if (this.$store.state.data.index.other) {
//          const $html = jQuery(this.$store.state.data.index.other)
//          const htmlText = $html.text()
//
//          // html
//          this.html = $html.prop('outerHTML')
//
//          // text
//          this.text = textify(this.html)
//
//          // target
//          this.target = $html.attr('index') ? $html.attr('index') : this.html
//      } else {
//          const $html = jQuery('a.v[active=true]')
//
//          // html
//          this.html = ''
//          for (let i = 0; i < $html.length; i++) {
//            const $item = jQuery($html[i])
//            this.html += $item.html() + '<br>'
//          }
//
//          // text
//          this.text = this.$store.state.data.current.verse.text
//
//          // target
//          this.target = this.$store.state.data.current.verse.code
//
//          // parallel
//          this.parallel = {}
//          this.$store.dispatch('dataBibleVerse', this.$store.state.data.index)
//            .then((response) => {
//              this.parallel = Object.assign({}, response.data)
//            })
//
//          // last_verse
//          this.last_verse = {}
//          this.$store.dispatch('dataBibleLastVerse', this.$store.state.data.index)
//            .then((response) => {
//              this.last_verse = Object.assign({}, response.data)
//            })
//      }
//      this.html = this.html.trim().replace(/^<br>/, '').replace(/<br>$/, '')
    },

    onHidden(event) {
      this.$store.dispatch('dataSetIndex', {
        indexes: {
          other: null,
        },
      })
    },

    onClickCopy(event) {
      console.log('copyChapter');

      const textarea = document.getElementById('textarea-for-copy-chapter');
      const style = textarea.attributes.style.value;
      textarea.style.display = '';

      // for not ios
      textarea.select();
      // for ios
      textarea.setSelectionRange(0, textarea.value.length);

      document.execCommand('copy');
      textarea.style.display = 'none';
    },

    onCopyNativeTextAreaForCopy(event) {
      event.stopPropagation()
    },

    onClickLastVerse(event) {
      this.$store.dispatch('uiToggleModalBibleAction', false)
      this.$store.dispatch('dataBibleOpenWithIndex', {
        bible: this.last_verse.bible_code,
        book: this.last_verse.bible_book_code,
        chapter: this.last_verse.chapter_order,
        verse: this.last_verse.order,
        pushHistory: true,
      })
    },
  },

  created: function() {
  },

  beforeDestroy: function () {
  }
}
</script>

<style lang="scss">
.bible-open-body {
  .tabs {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    .card-header {
      .nav-tabs {
        display: flex;

        li.nav-item {
          flex-grow: 1;

          a.nav-link {
            text-align: center;

            &.active {
              border-color: #dee2e6;
            }
          }
        }
      }
    }

    .tab-content {
      flex-grow: 1;
      overflow-y: scroll;

      .tab-pane {
        .row {
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }

          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
        }
      }
    }
  }
}
</style>

